import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";

export const ManagerAccessLevelDetail = ({accessSelectedItemId = -1, changeNeedRefresh}) => {

    let page = 0
    const size = 10

    const service = new ManagerAccessLevelService()


    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [englishName, setEnglishName] = useState("");
    const [name, setName] = useState("");

    const [pageCount, setPageCount] = useState(2);
    const [accessList, setAccessList] = useState([]);
    const [accessSelectedItems, setAccessSelectedItems] = useState([]);
    const [accessTableLoadingState, setAccessTableLoadingState] = useState(false);


    useEffect(() => {
        if (service) {
            getPermissionsListFromServer()
        }
    }, [])

    useEffect(() => {
        if (accessSelectedItemId && accessSelectedItemId !== -1) {
            getRoleInfoFromServer()
        }
    }, [accessSelectedItemId])

    function getRoleInfoFromServer() {
        loading.show()
        service.getRoleInfo(accessSelectedItemId)
            .then(response => {
                setName(response.name)
                setAccessSelectedItems(response.permissions)
                loading.hide()
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    function prepareRoleListRow(number, id, name) {
        return {
            number,
            id,
            name
        }
    }

    function getPermissionsListFromServer() {
        // setAccessTableLoadingState(true)
        service.getPermissionsList(page, size)
            .then(response => {

                const _list = []
                response.data.map((item, index) => {
                    _list.push(
                        prepareRoleListRow(
                            (page * size) + index + 1,
                            item.id,
                            item.name
                        )
                    )
                })

                setAccessList(_list)

                setPageCount(response.totalPage)
                setAccessTableLoadingState(false)

            }).catch(reason => {
            setAccessTableLoadingState(false)
            showErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getPermissionsListFromServer()
    }

    function handleChangeAccess() {
        doAddNewAccess()
    }

    function clearFields() {
        setName("")
        setAccessSelectedItems([])
    }

    function doAddNewAccess() {
        if (checkFields()) {
            loading.show()
            service.addNewRole(name, englishName, [])
                .then(response => {
                    changeNeedRefresh(true)
                    showSuccessMessage("سطح دسترسی جدید با موفقیت افزوده شد!")
                    clearFields()
                }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage())
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (name.length === 0) {
            message = "لطفا نام دسترسی را وارد نمایید!"
        } else if (englishName.length === 0) {
            message = "لطفا slug دسترسی را وارد نمایید"
        } else {
            state = true
        }

        showErrorMessage(message)

        return state


    }

    function doUpdateExistingAccess() {
        if (checkFields()) {
            loading.show()
            service.updateRoleInfo(
                accessSelectedItemId,
                name,
                accessSelectedItems
            ).then(response => {
                changeNeedRefresh(true)
                showSuccessMessage("بروزرسانی با موفقیت انجام شد!")
                loading.hide()
            }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage())
                loading.hide()
            })

        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoGridOneColumn>
                <RaikoMaterialOutlinedInput value={name} setValue={setName} labelText={"عنوان"}/>
                <RaikoMaterialOutlinedInput value={englishName} setValue={setEnglishName} labelText={"slug"}/>
            </RaikoGridOneColumn>

            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={accessSelectedItemId && accessSelectedItemId.length > 0 ? "بروزرسانی" : "افزودن"}
                    onClick={handleChangeAccess}
                />
            </RaikoFlexAlignEnd>
        </RaikoGridOneColumn>
    )
}


const accessTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "name",
        label: "عنوان"
    },
    {
        id: "access",
        label: "سطح دسترسی"
    }
]